import React, { Component } from 'react';
import Icon from './Icon.js';
import './Svg.scss';
import './Icon.scss';

export default class ExpandIcon extends Component {
    render () {
        let finalClassName = Icon.buildCssClass(this.props);

        return (
            <svg className={finalClassName} width="22" height="22" viewBox="0 0 22 22">
                <path d="M583.992 247.854L600.963 230.88400000000001L603.51 233.43L586.538 250.4Z " transform="matrix(1,0,0,1,-583,-230)"></path>
                <path d="M604.005 247.854L587.034 230.88400000000001L584.489 233.43L601.4590000000001 250.4Z " transform="matrix(1,0,0,1,-583,-230)"></path>
            </svg>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/icon/Close.js